import { ReactComponent as accountMenu } from '../../assets/menu-icons/accountMenu.svg'
import { ReactComponent as addSolidSystem } from '../../assets/system-icons/addSolidSystem.svg'
import { ReactComponent as addSystem } from '../../assets/system-icons/addSystem.svg'
import { ReactComponent as agencyCloudInfographic } from '../../assets/infographic-icons/agencyCloudInfographic.svg'
import { ReactComponent as analyticsMenu } from '../../assets/menu-icons/analyticsMenu.svg'
import { ReactComponent as apiDocsInfographic } from '../../assets/infographic-icons/apiDocsInfographic.svg'
import { ReactComponent as apiInfographic } from '../../assets/infographic-icons/apiInfographic.svg'
import { ReactComponent as apiMenu } from '../../assets/menu-icons/apiMenu.svg'
import { ReactComponent as appCategoryInfographic } from '../../assets/infographic-icons/appCategoryInfographic.svg'
import { ReactComponent as appInfographic } from '../../assets/infographic-icons/appInfographic.svg'
import { ReactComponent as appInfographicAlt } from '../../assets/infographic-icons/appInfographicAlt.svg'
import { ReactComponent as applicantInfographic } from '../../assets/infographic-icons/applicantInfographic.svg'
import { ReactComponent as appLauncherMenu } from '../../assets/menu-icons/appLauncherMenu.svg'
import { ReactComponent as appMarketDarkInfographic } from '../../assets/infographic-icons/appMarketDarkInfographic.svg'
import { ReactComponent as appMarketInfographic } from '../../assets/infographic-icons/appMarketInfographic.svg'
import { ReactComponent as appSettingsAuthDarkInfographic } from '../../assets/infographic-icons/appSettingsAuthDarkInfographic.svg'
import { ReactComponent as appSettingsAuthInfographic } from '../../assets/infographic-icons/appSettingsAuthInfographic.svg'
import { ReactComponent as appsMenu } from '../../assets/menu-icons/appsMenu.svg'
import { ReactComponent as appTypeInfographic } from '../../assets/infographic-icons/appTypeInfographic.svg'
import { ReactComponent as arrowDownSolidSystem } from '../../assets/system-icons/arrowDownSolidSystem.svg'
import { ReactComponent as arrowDownSystem } from '../../assets/system-icons/arrowDownSystem.svg'
import { ReactComponent as arrowLeftSolidSystem } from '../../assets/system-icons/arrowLeftSolidSystem.svg'
import { ReactComponent as arrowLeftSystem } from '../../assets/system-icons/arrowLeftSystem.svg'
import { ReactComponent as arrowRightSolidSystem } from '../../assets/system-icons/arrowRightSolidSystem.svg'
import { ReactComponent as arrowRightSystem } from '../../assets/system-icons/arrowRightSystem.svg'
import { ReactComponent as arrowUpSolidSystem } from '../../assets/system-icons/arrowUpSolidSystem.svg'
import { ReactComponent as arrowUpSystem } from '../../assets/system-icons/arrowUpSystem.svg'
import { ReactComponent as asteriskSolidSystem } from '../../assets/system-icons/asteriskSolidSystem.svg'
import { ReactComponent as asteriskSystem } from '../../assets/system-icons/asteriskSystem.svg'
import { ReactComponent as authenticatedInfographic } from '../../assets/infographic-icons/authenticatedInfographic.svg'
import { ReactComponent as authenticationSolidSystem } from '../../assets/system-icons/authenticationSolidSystem.svg'
import { ReactComponent as authenticationSystem } from '../../assets/system-icons/authenticationSystem.svg'
import { ReactComponent as backSolidSystem } from '../../assets/system-icons/backSolidSystem.svg'
import { ReactComponent as backSystem } from '../../assets/system-icons/backSystem.svg'
import { ReactComponent as barnInfographic } from '../../assets/infographic-icons/barnInfographic.svg'
import { ReactComponent as bulletListSolidSystem } from '../../assets/system-icons/bulletListSolidSystem.svg'
import { ReactComponent as bulletListSystem } from '../../assets/system-icons/bulletListSystem.svg'
import { ReactComponent as bungalowInfographic } from '../../assets/infographic-icons/bungalowInfographic.svg'
import { ReactComponent as calendarSolidSystem } from '../../assets/system-icons/calendarSolidSystem.svg'
import { ReactComponent as calendarSystem } from '../../assets/system-icons/calendarSystem.svg'
import { ReactComponent as cancelSolidSystem } from '../../assets/system-icons/cancelSolidSystem.svg'
import { ReactComponent as cancelSystem } from '../../assets/system-icons/cancelSystem.svg'
import { ReactComponent as carSolidSystem } from '../../assets/system-icons/carSolidSystem.svg'
import { ReactComponent as carSystem } from '../../assets/system-icons/carSystem.svg'
import { ReactComponent as checkSolidSystem } from '../../assets/system-icons/checkSolidSystem.svg'
import { ReactComponent as checkSystem } from '../../assets/system-icons/checkSystem.svg'
import { ReactComponent as circleSolidSystem } from '../../assets/system-icons/circleSolidSystem.svg'
import { ReactComponent as circleSystem } from '../../assets/system-icons/circleSystem.svg'
import { ReactComponent as closeSolidSystem } from '../../assets/system-icons/closeSolidSystem.svg'
import { ReactComponent as closeSystem } from '../../assets/system-icons/closeSystem.svg'
import { ReactComponent as cloudSolidSystem } from '../../assets/system-icons/cloudSolidSystem.svg'
import { ReactComponent as cloudSystem } from '../../assets/system-icons/cloudSystem.svg'
import { ReactComponent as codeInfographic } from '../../assets/infographic-icons/codeInfographic.svg'
import { ReactComponent as companySolidSystem } from '../../assets/system-icons/companySolidSystem.svg'
import { ReactComponent as companySystem } from '../../assets/system-icons/companySystem.svg'
import { ReactComponent as cottageInfographic } from '../../assets/infographic-icons/cottageInfographic.svg'
import { ReactComponent as crmInfographic } from '../../assets/infographic-icons/crmInfographic.svg'
import { ReactComponent as customerInfographic } from '../../assets/infographic-icons/customerInfographic.svg'
import { ReactComponent as dataMenu } from '../../assets/menu-icons/dataMenu.svg'
import { ReactComponent as defaultMenu } from '../../assets/menu-icons/defaultMenu.svg'
import { ReactComponent as designInfographic } from '../../assets/infographic-icons/designInfographic.svg'
import { ReactComponent as desktopMenu } from '../../assets/menu-icons/desktopMenu.svg'
import { ReactComponent as developerAppsInfographic } from '../../assets/infographic-icons/developerAppsInfographic.svg'
import { ReactComponent as developersMenu } from '../../assets/menu-icons/developersMenu.svg'
import { ReactComponent as developmentInfographic } from '../../assets/infographic-icons/developmentInfographic.svg'
import { ReactComponent as devicesInfographic } from '../../assets/infographic-icons/devicesInfographic.svg'
import { ReactComponent as docsAnimated1 } from '../../assets/animated-icons/docsAnimated1.svg'
import { ReactComponent as docsAnimated2 } from '../../assets/animated-icons/docsAnimated2.svg'
import { ReactComponent as docsInfographic } from '../../assets/infographic-icons/docsInfographic.svg'
import { ReactComponent as docsMenu } from '../../assets/menu-icons/docsMenu.svg'
import { ReactComponent as dollarSolidSystem } from '../../assets/system-icons/dollarSolidSystem.svg'
import { ReactComponent as dollarSystem } from '../../assets/system-icons/dollarSystem.svg'
import { ReactComponent as doorLockInfographic } from '../../assets/infographic-icons/doorLockInfographic.svg'
import { ReactComponent as downloadSolidSystem } from '../../assets/system-icons/downloadSolidSystem.svg'
import { ReactComponent as downloadSystem } from '../../assets/system-icons/downloadSystem.svg'
import { ReactComponent as downSolidSystem } from '../../assets/system-icons/downSolidSystem.svg'
import { ReactComponent as downSystem } from '../../assets/system-icons/downSystem.svg'
import { ReactComponent as editAppCancelInfographic } from '../../assets/infographic-icons/editAppCancelInfographic.svg'
import { ReactComponent as editAppInfographic } from '../../assets/infographic-icons/editAppInfographic.svg'
import { ReactComponent as editSolidSystem } from '../../assets/system-icons/editSolidSystem.svg'
import { ReactComponent as editSystem } from '../../assets/system-icons/editSystem.svg'
import { ReactComponent as elementsInfographic } from '../../assets/infographic-icons/elementsInfographic.svg'
import { ReactComponent as emailSolidSystem } from '../../assets/system-icons/emailSolidSystem.svg'
import { ReactComponent as emailSystem } from '../../assets/system-icons/emailSystem.svg'
import { ReactComponent as errorSolidSystem } from '../../assets/system-icons/errorSolidSystem.svg'
import { ReactComponent as errorSystem } from '../../assets/system-icons/errorSystem.svg'
import { ReactComponent as euroSolidSystem } from '../../assets/system-icons/euroSolidSystem.svg'
import { ReactComponent as euroSystem } from '../../assets/system-icons/euroSystem.svg'
import { ReactComponent as farmInfographic } from '../../assets/infographic-icons/farmInfographic.svg'
import { ReactComponent as favouriteSolidSystem } from '../../assets/system-icons/favouriteSolidSystem.svg'
import { ReactComponent as favouriteSystem } from '../../assets/system-icons/favouriteSystem.svg'
import { ReactComponent as feedAltInfographic } from '../../assets/infographic-icons/feedAltInfographic.svg'
import { ReactComponent as feedInfographic } from '../../assets/infographic-icons/feedInfographic.svg'
import { ReactComponent as filterSolidSystem } from '../../assets/system-icons/filterSolidSystem.svg'
import { ReactComponent as filterSystem } from '../../assets/system-icons/filterSystem.svg'
import { ReactComponent as flatInfographic } from '../../assets/infographic-icons/flatInfographic.svg'
import { ReactComponent as foundationsCustomerInfographic } from '../../assets/infographic-icons/foundationsCustomerInfographic.svg'
import { ReactComponent as geoLocationSolidSystem } from '../../assets/system-icons/geoLocationSolidSystem.svg'
import { ReactComponent as geoLocationSystem } from '../../assets/system-icons/geoLocationSystem.svg'
import { ReactComponent as githubSolidSystem } from '../../assets/system-icons/githubSolidSystem.svg'
import { ReactComponent as githubSystem } from '../../assets/system-icons/githubSystem.svg'
import { ReactComponent as globeInfographic } from '../../assets/infographic-icons/globeInfographic.svg'
import { ReactComponent as graphQlInfographic } from '../../assets/infographic-icons/graphQlInfographic.svg'
import { ReactComponent as hamburgerMenu } from '../../assets/menu-icons/hamburgerMenu.svg'
import { ReactComponent as hamburgerMenuSolidSystem } from '../../assets/system-icons/hamburgerMenuSolidSystem.svg'
import { ReactComponent as hamburgerMenuSystem } from '../../assets/system-icons/hamburgerMenuSystem.svg'
import { ReactComponent as hamburgerOpenMenu } from '../../assets/menu-icons/hamburgerOpenMenu.svg'
import { ReactComponent as helpMenu } from '../../assets/menu-icons/helpMenu.svg'
import { ReactComponent as hideSolidSystem } from '../../assets/system-icons/hideSolidSystem.svg'
import { ReactComponent as hideSystem } from '../../assets/system-icons/hideSystem.svg'
import { ReactComponent as homeSolidSystem } from '../../assets/system-icons/homeSolidSystem.svg'
import { ReactComponent as homeSystem } from '../../assets/system-icons/homeSystem.svg'
import { ReactComponent as houseInfographic } from '../../assets/infographic-icons/houseInfographic.svg'
import { ReactComponent as htmlInfographic } from '../../assets/infographic-icons/htmlInfographic.svg'
import { ReactComponent as infoSolidSystem } from '../../assets/system-icons/infoSolidSystem.svg'
import { ReactComponent as infoSystem } from '../../assets/system-icons/infoSystem.svg'
import { ReactComponent as installedMenu } from '../../assets/menu-icons/installedMenu.svg'
import { ReactComponent as landInfographic } from '../../assets/infographic-icons/landInfographic.svg'
import { ReactComponent as landlordInfographic } from '../../assets/infographic-icons/landlordInfographic.svg'
import { ReactComponent as leadGenerationInfographic } from '../../assets/infographic-icons/leadGenerationInfographic.svg'
import { ReactComponent as linkSolidSystem } from '../../assets/system-icons/linkSolidSystem.svg'
import { ReactComponent as linkSystem } from '../../assets/system-icons/linkSystem.svg'
import { ReactComponent as listInfographic } from '../../assets/infographic-icons/listInfographic.svg'
import { ReactComponent as lockedInfographic } from '../../assets/infographic-icons/lockedInfographic.svg'
import { ReactComponent as lockSolidSystem } from '../../assets/system-icons/lockSolidSystem.svg'
import { ReactComponent as lockSystem } from '../../assets/system-icons/lockSystem.svg'
import { ReactComponent as logoKeyInfographic } from '../../assets/infographic-icons/logoKeyInfographic.svg'
import { ReactComponent as logoSettingsInfographic } from '../../assets/infographic-icons/logoSettingsInfographic.svg'
import { ReactComponent as logoutMenu } from '../../assets/menu-icons/logoutMenu.svg'
import { ReactComponent as mailInfographic } from '../../assets/infographic-icons/mailInfographic.svg'
import { ReactComponent as maisonetteInfographic } from '../../assets/infographic-icons/maisonetteInfographic.svg'
import { ReactComponent as manageAppListingInfographic } from '../../assets/infographic-icons/manageAppListingInfographic.svg'
import { ReactComponent as manageMenu } from '../../assets/menu-icons/manageMenu.svg'
import { ReactComponent as manageWebhooksInfographic } from '../../assets/infographic-icons/manageWebhooksInfographic.svg'
import { ReactComponent as mapMenu } from '../../assets/menu-icons/mapMenu.svg'
import { ReactComponent as marketingInfographic } from '../../assets/infographic-icons/marketingInfographic.svg'
import { ReactComponent as marketplaceAppACInfographic } from '../../assets/infographic-icons/marketplaceAppACInfographic.svg'
import { ReactComponent as marketplaceMenu } from '../../assets/menu-icons/marketplaceMenu.svg'
import { ReactComponent as messageSolidSystem } from '../../assets/system-icons/messageSolidSystem.svg'
import { ReactComponent as messageSystem } from '../../assets/system-icons/messageSystem.svg'
import { ReactComponent as moreSolidSystem } from '../../assets/system-icons/moreSolidSystem.svg'
import { ReactComponent as moreSystem } from '../../assets/system-icons/moreSystem.svg'
import { ReactComponent as myAccountMenu } from '../../assets/menu-icons/myAccountMenu.svg'
import { ReactComponent as myAppsInfographic } from '../../assets/infographic-icons/myAppsInfographic.svg'
import { ReactComponent as newCustomerInfographic } from '../../assets/infographic-icons/newCustomerInfographic.svg'
import { ReactComponent as nextSolidSystem } from '../../assets/system-icons/nextSolidSystem.svg'
import { ReactComponent as nextSystem } from '../../assets/system-icons/nextSystem.svg'
import { ReactComponent as officesMenu } from '../../assets/menu-icons/officesMenu.svg'
import { ReactComponent as paymentsMenu } from '../../assets/menu-icons/paymentsMenu.svg'
import { ReactComponent as paymentSolidSystem } from '../../assets/system-icons/paymentSolidSystem.svg'
import { ReactComponent as paymentSystem } from '../../assets/system-icons/paymentSystem.svg'
import { ReactComponent as phoneInfographic } from '../../assets/infographic-icons/phoneInfographic.svg'
import { ReactComponent as phoneSolidSystem } from '../../assets/system-icons/phoneSolidSystem.svg'
import { ReactComponent as phoneSystem } from '../../assets/system-icons/phoneSystem.svg'
import { ReactComponent as pinSolidSystem } from '../../assets/system-icons/pinSolidSystem.svg'
import { ReactComponent as pinSystem } from '../../assets/system-icons/pinSystem.svg'
import { ReactComponent as platformApiInfographic } from '../../assets/infographic-icons/platformApiInfographic.svg'
import { ReactComponent as poundSolidSystem } from '../../assets/system-icons/poundSolidSystem.svg'
import { ReactComponent as poundSystem } from '../../assets/system-icons/poundSystem.svg'
import { ReactComponent as previewSystem } from '../../assets/system-icons/previewSystem.svg'
import { ReactComponent as productivityInfographic } from '../../assets/infographic-icons/productivityInfographic.svg'
import { ReactComponent as profileMenu } from '../../assets/menu-icons/profileMenu.svg'
import { ReactComponent as propertyManagementInfographic } from '../../assets/infographic-icons/propertyManagementInfographic.svg'
import { ReactComponent as propTechInfographic } from '../../assets/infographic-icons/propTechInfographic.svg'
import { ReactComponent as questionSolidSystem } from '../../assets/system-icons/questionSolidSystem.svg'
import { ReactComponent as questionSystem } from '../../assets/system-icons/questionSystem.svg'
import { ReactComponent as reapitConnectInfographic } from '../../assets/infographic-icons/reapitConnectInfographic.svg'
import { ReactComponent as reapitConnectSettingsDevicesDarkInfographic } from '../../assets/infographic-icons/reapitConnectSettingsDevicesDarkInfographic.svg'
import { ReactComponent as reapitConnectSettingsDevicesInfographic } from '../../assets/infographic-icons/reapitConnectSettingsDevicesInfographic.svg'
import { ReactComponent as reapitLogoInfographic } from '../../assets/infographic-icons/reapitLogoInfographic.svg'
import { ReactComponent as reapitLogoSmallInfographic } from '../../assets/infographic-icons/reapitLogoSmallInfographic.svg'
import { ReactComponent as reapitLogoMenu } from '../../assets/menu-icons/reapitLogoMenu.svg'
import { ReactComponent as reapitLogoSelectedMenu } from '../../assets/menu-icons/reapitLogoSelectedMenu.svg'
import { ReactComponent as reapitLogoTextMenu } from '../../assets/menu-icons/reapitLogoTextMenu.svg'
import { ReactComponent as reapitUserInfographic } from '../../assets/infographic-icons/reapitUserInfographic.svg'
import { ReactComponent as refreshInfographic } from '../../assets/infographic-icons/refreshInfographic.svg'
import { ReactComponent as refreshSolidSystem } from '../../assets/system-icons/refreshSolidSystem.svg'
import { ReactComponent as refreshSystem } from '../../assets/system-icons/refreshSystem.svg'
import { ReactComponent as reportInfographic } from '../../assets/infographic-icons/reportInfographic.svg'
import { ReactComponent as reportingInfographic } from '../../assets/infographic-icons/reportingInfographic.svg'
import { ReactComponent as resultsMenu } from '../../assets/menu-icons/resultsMenu.svg'
import { ReactComponent as salesProgressionInfographic } from '../../assets/infographic-icons/salesProgressionInfographic.svg'
import { ReactComponent as saveSystem } from '../../assets/system-icons/saveSystem.svg'
import { ReactComponent as searchMenu } from '../../assets/menu-icons/searchMenu.svg'
import { ReactComponent as searchSolidSystem } from '../../assets/system-icons/searchSolidSystem.svg'
import { ReactComponent as searchSystem } from '../../assets/system-icons/searchSystem.svg'
import { ReactComponent as securityTokenSolidSystem } from '../../assets/system-icons/securityTokenSolidSystem.svg'
import { ReactComponent as securityTokenSystem } from '../../assets/system-icons/securityTokenSystem.svg'
import { ReactComponent as selectInfographic } from '../../assets/infographic-icons/selectInfographic.svg'
import { ReactComponent as serverInfographic } from '../../assets/infographic-icons/serverInfographic.svg'
import { ReactComponent as settingsSolidSystem } from '../../assets/system-icons/settingsSolidSystem.svg'
import { ReactComponent as settingsSystem } from '../../assets/system-icons/settingsSystem.svg'
import { ReactComponent as sharedEntitiesInfographic } from '../../assets/infographic-icons/sharedEntitiesInfographic.svg'
import { ReactComponent as shareSolidSystem } from '../../assets/system-icons/shareSolidSystem.svg'
import { ReactComponent as shareSystem } from '../../assets/system-icons/shareSystem.svg'
import { ReactComponent as shieldInfographic } from '../../assets/infographic-icons/shieldInfographic.svg'
import { ReactComponent as sortSolidSystem } from '../../assets/system-icons/sortSolidSystem.svg'
import { ReactComponent as sortSystem } from '../../assets/system-icons/sortSystem.svg'
import { ReactComponent as supportMenu } from '../../assets/menu-icons/supportMenu.svg'
import { ReactComponent as tickSolidSystem } from '../../assets/system-icons/tickSolidSystem.svg'
import { ReactComponent as tickSystem } from '../../assets/system-icons/tickSystem.svg'
import { ReactComponent as trashSolidSystem } from '../../assets/system-icons/trashSolidSystem.svg'
import { ReactComponent as trashSystem } from '../../assets/system-icons/trashSystem.svg'
import { ReactComponent as uiMenu } from '../../assets/menu-icons/uiMenu.svg'
import { ReactComponent as upSolidSystem } from '../../assets/system-icons/upSolidSystem.svg'
import { ReactComponent as upSystem } from '../../assets/system-icons/upSystem.svg'
import { ReactComponent as userAuthInfographic } from '../../assets/infographic-icons/userAuthInfographic.svg'
import { ReactComponent as userDeviceInfographic } from '../../assets/infographic-icons/userDeviceInfographic.svg'
import { ReactComponent as userHouseInfographic } from '../../assets/infographic-icons/userHouseInfographic.svg'
import { ReactComponent as userInfographic } from '../../assets/infographic-icons/userInfographic.svg'
import { ReactComponent as usernameSolidSystem } from '../../assets/system-icons/usernameSolidSystem.svg'
import { ReactComponent as usernameSystem } from '../../assets/system-icons/usernameSystem.svg'
import { ReactComponent as usersMenu } from '../../assets/menu-icons/usersMenu.svg'
import { ReactComponent as utilityRegistrationInfographic } from '../../assets/infographic-icons/utilityRegistrationInfographic.svg'
import { ReactComponent as vendorInfographic } from '../../assets/infographic-icons/vendorInfographic.svg'
import { ReactComponent as videoSolidSystem } from '../../assets/system-icons/videoSolidSystem.svg'
import { ReactComponent as videoSystem } from '../../assets/system-icons/videoSystem.svg'
import { ReactComponent as viewSolidSystem } from '../../assets/system-icons/viewSolidSystem.svg'
import { ReactComponent as viewSystem } from '../../assets/system-icons/viewSystem.svg'
import { ReactComponent as walkingSolidSystem } from '../../assets/system-icons/walkingSolidSystem.svg'
import { ReactComponent as walkingSystem } from '../../assets/system-icons/walkingSystem.svg'
import { ReactComponent as warningSolidSystem } from '../../assets/system-icons/warningSolidSystem.svg'
import { ReactComponent as warningSystem } from '../../assets/system-icons/warningSystem.svg'
import { ReactComponent as webDeveloperInfographic } from '../../assets/infographic-icons/webDeveloperInfographic.svg'
import { ReactComponent as webDeveloperInfographicAlt } from '../../assets/infographic-icons/webDeveloperInfographicAlt.svg'
import { ReactComponent as webhooksAnimated1 } from '../../assets/animated-icons/webhooksAnimated1.svg'
import { ReactComponent as webhooksAnimated2 } from '../../assets/animated-icons/webhooksAnimated2.svg'
import { ReactComponent as webhooksDocsAnimated1 } from '../../assets/animated-icons/webhooksDocsAnimated1.svg'
import { ReactComponent as webhooksDocsAnimated2 } from '../../assets/animated-icons/webhooksDocsAnimated2.svg'
import { ReactComponent as webhooksDocsInfographic } from '../../assets/infographic-icons/webhooksDocsInfographic.svg'
import { ReactComponent as webhooksInfographic } from '../../assets/infographic-icons/webhooksInfographic.svg'
import { ReactComponent as webhooksMenu } from '../../assets/menu-icons/webhooksMenu.svg'
import { ReactComponent as webInfographic } from '../../assets/infographic-icons/webInfographic.svg'
import { ReactComponent as welcomeAnimated1 } from '../../assets/animated-icons/welcomeAnimated1.svg'
import { ReactComponent as welcomeAnimated2 } from '../../assets/animated-icons/welcomeAnimated2.svg'
import { ReactComponent as welcomeInfographic } from '../../assets/infographic-icons/welcomeInfographic.svg'

export const iconSetLegacy = {
  appCategoryInfographic,
  agencyCloudInfographic,
  apiDocsInfographic,
  apiInfographic,
  appInfographic,
  appInfographicAlt,
  applicantInfographic,
  appMarketDarkInfographic,
  appMarketInfographic,
  appSettingsAuthDarkInfographic,
  appSettingsAuthInfographic,
  appTypeInfographic,
  barnInfographic,
  bungalowInfographic,
  codeInfographic,
  cottageInfographic,
  crmInfographic,
  customerInfographic,
  designInfographic,
  developerAppsInfographic,
  developmentInfographic,
  devicesInfographic,
  docsInfographic,
  doorLockInfographic,
  editAppCancelInfographic,
  editAppInfographic,
  elementsInfographic,
  farmInfographic,
  feedAltInfographic,
  feedInfographic,
  flatInfographic,
  foundationsCustomerInfographic,
  globeInfographic,
  graphQlInfographic,
  houseInfographic,
  htmlInfographic,
  landInfographic,
  landlordInfographic,
  leadGenerationInfographic,
  listInfographic,
  lockedInfographic,
  logoKeyInfographic,
  logoSettingsInfographic,
  mailInfographic,
  maisonetteInfographic,
  manageAppListingInfographic,
  manageWebhooksInfographic,
  marketingInfographic,
  marketplaceAppACInfographic,
  myAppsInfographic,
  newCustomerInfographic,
  phoneInfographic,
  productivityInfographic,
  propertyManagementInfographic,
  propTechInfographic,
  reapitConnectInfographic,
  reapitConnectSettingsDevicesDarkInfographic,
  reapitConnectSettingsDevicesInfographic,
  reapitLogoInfographic,
  reapitLogoSmallInfographic,
  reapitUserInfographic,
  refreshInfographic,
  reportInfographic,
  reportingInfographic,
  salesProgressionInfographic,
  selectInfographic,
  serverInfographic,
  shieldInfographic,
  userAuthInfographic,
  userDeviceInfographic,
  userHouseInfographic,
  userInfographic,
  utilityRegistrationInfographic,
  vendorInfographic,
  webDeveloperInfographic,
  webDeveloperInfographicAlt,
  webhooksDocsInfographic,
  webhooksInfographic,
  webInfographic,
  welcomeInfographic,
  // Thin System Icons
  addSystem,
  arrowDownSystem,
  arrowLeftSystem,
  arrowRightSystem,
  arrowUpSystem,
  asteriskSystem,
  authenticationSystem,
  backSystem,
  bulletListSystem,
  calendarSystem,
  cancelSystem,
  carSystem,
  checkSystem,
  circleSystem,
  closeSystem,
  cloudSystem,
  companySystem,
  dollarSystem,
  downloadSystem,
  downSystem,
  editSystem,
  emailSystem,
  errorSystem,
  euroSystem,
  favouriteSystem,
  filterSystem,
  geoLocationSystem,
  githubSystem,
  hamburgerMenuSystem,
  hideSystem,
  homeSystem,
  infoSystem,
  linkSystem,
  lockSystem,
  messageSystem,
  moreSystem,
  nextSystem,
  paymentSystem,
  phoneSystem,
  pinSystem,
  poundSystem,
  questionSystem,
  refreshSystem,
  searchSystem,
  securityTokenSystem,
  settingsSystem,
  shareSystem,
  sortSystem,
  trashSystem,
  upSystem,
  usernameSystem,
  videoSystem,
  viewSystem,
  walkingSystem,
  warningSystem,
  // Solid System Icons
  addSolidSystem,
  arrowDownSolidSystem,
  arrowLeftSolidSystem,
  arrowRightSolidSystem,
  arrowUpSolidSystem,
  asteriskSolidSystem,
  authenticationSolidSystem,
  backSolidSystem,
  bulletListSolidSystem,
  calendarSolidSystem,
  cancelSolidSystem,
  carSolidSystem,
  checkSolidSystem,
  circleSolidSystem,
  closeSolidSystem,
  cloudSolidSystem,
  companySolidSystem,
  dollarSolidSystem,
  downloadSolidSystem,
  downSolidSystem,
  editSolidSystem,
  emailSolidSystem,
  errorSolidSystem,
  euroSolidSystem,
  favouriteSolidSystem,
  filterSolidSystem,
  geoLocationSolidSystem,
  githubSolidSystem,
  hamburgerMenuSolidSystem,
  hideSolidSystem,
  homeSolidSystem,
  infoSolidSystem,
  linkSolidSystem,
  lockSolidSystem,
  messageSolidSystem,
  moreSolidSystem,
  nextSolidSystem,
  paymentSolidSystem,
  phoneSolidSystem,
  pinSolidSystem,
  poundSolidSystem,
  questionSolidSystem,
  refreshSolidSystem,
  searchSolidSystem,
  securityTokenSolidSystem,
  settingsSolidSystem,
  shareSolidSystem,
  sortSolidSystem,
  trashSolidSystem,
  upSolidSystem,
  usernameSolidSystem,
  videoSolidSystem,
  viewSolidSystem,
  walkingSolidSystem,
  warningSolidSystem,
  // Menu Icons
  accountMenu,
  appLauncherMenu,
  analyticsMenu,
  apiMenu,
  appsMenu,
  dataMenu,
  defaultMenu,
  desktopMenu,
  developersMenu,
  docsMenu,
  hamburgerMenu,
  hamburgerOpenMenu,
  helpMenu,
  installedMenu,
  logoutMenu,
  manageMenu,
  mapMenu,
  marketplaceMenu,
  myAccountMenu,
  officesMenu,
  paymentsMenu,
  profileMenu,
  reapitLogoMenu,
  reapitLogoSelectedMenu,
  reapitLogoTextMenu,
  resultsMenu,
  searchMenu,
  supportMenu,
  uiMenu,
  usersMenu,
  webhooksMenu,

  // Deprecated Icons
  /** @deprecated */
  docsAnimated1,
  /** @deprecated */
  docsAnimated2,
  /** @deprecated */
  webhooksAnimated1,
  /** @deprecated */
  webhooksAnimated2,
  /** @deprecated */
  webhooksDocsAnimated1,
  /** @deprecated */
  webhooksDocsAnimated2,
  /** @deprecated */
  welcomeAnimated1,
  /** @deprecated */
  welcomeAnimated2,
  /** @deprecated */
  saveSystem,
  /** @deprecated */
  tickSolidSystem,
  /** @deprecated */
  tickSystem,
  /** @deprecated */
  previewSystem,
  /** @deprecated */
  authenticatedInfographic,
  /** @deprecated */
  platformApiInfographic,
  /** @deprecated */
  sharedEntitiesInfographic,
}
